import React from 'react';
import { useTranslation } from 'react-i18next';

const EconomicalTariffItemHeader = () => {
  // translations
  const t = useTranslation("economicalTariff\\economicalTariff").t;

  return (
    <div className="d-none d-lg-block px-3 mb-2 text-muted font-weight-bold">
      <div className="row no-gutters">
        <div className="col-sm-3">
          {t("economicalTariffItem.placeOfDelivery")}
        </div>
        <div className="col-sm-3 text-center">
          {t("economicalTariffItem.distributionRate")}
        </div>
        <div className="col-sm-3 text-center">
          {t("economicalTariffItem.paymentDate")}
        </div>
        <div className="col-sm-3 text-right">
          {t("economicalTariffItem.amount")}
        </div>
      </div>
    </div>
  )
}

export default EconomicalTariffItemHeader;